import React, { useId } from 'react';

import { isImportedContribution } from '~support-at-home/lib/contributionRows';

import { TooltipIcon } from '~components';
import { faLock } from '~components/icon';
import { Row } from '~components/table-view';

interface ComponentProps {
  row?: Row;
}

// TAV-3421 source indicator. A lock marks a contribution imported from Services Australia (locked
// here, though it can still be removed). Hand-entered rows get no badge. Modelled on
// ServiceSourceBadge. Called as JSX from ContributionCategoryCell.
const ContributionSourceBadge: React.FC<ComponentProps> = ({ row }) => {
  // Per-instance fallback so two badges without a row id do not share a tooltip anchor.
  const fallbackId = useId();

  if (!row || !isImportedContribution(row)) return null;

  const tooltipId = row.id !== undefined ? String(row.id) : fallbackId;

  return (
    <span data-cy="sah-contribution-source-badge">
      <TooltipIcon
        id={`contribution-source-${tooltipId}`}
        icon={faLock}
        tooltip="Imported from Services Australia. Cannot be edited here."
        iconColor="dodgerblue"
      />
    </span>
  );
};

export default ContributionSourceBadge;
